// extracted by mini-css-extract-plugin
module.exports = {"ArticleLine":"styles_ArticleLine__2ROVx","article":"styles_article__E5VXe"};